// Where the virtual tabletop lives (docs/VTT/MVP-BUILD-PLAN.md §2.1): its own
// origin, baked at build time like REACT_APP_API_URL — so it goes in BOTH the
// compose build.args and client/Dockerfile's ARG/ENV pair (dev: vtt-dev, production:
// vtt.thedragonstable.com). Unset, the table is simply not offered anywhere.
export const VTT_URL = (process.env.REACT_APP_VTT_URL || '').replace(/\/+$/, '');
export const vttConfigured = () => VTT_URL.length > 0;
/**
 * The table's address on the VTT: the campaign's (VTT issue 1578; one table per campaign). The site's
 * /table/:campaignId page is what links here. An old party address passed through is resolved by the VTT.
 */
export const vttTableUrl = (campaignId, code) =>
  `${VTT_URL}/t/${encodeURIComponent(campaignId)}${code ? `#code=${encodeURIComponent(code)}` : ''}`;
